<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/video-main-banner.svg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">{{ $t("sales-list") }}</div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb
      v-if="!editMode"
      :trainingNameEdit="request.eventNumber ? request.eventNumber : ''"
    />
    <Breadcrumb v-else :trainingNameEdit="request.eventNumber" />
    <div class="pt-8">
      <div class="row disablerow align-items-start">
        <p
          v-if="request.completedStatus"
          class="col-xl-9 status_note text-center"
        >
          <span class="green_status"
            ><img src="/static/img/status_green.svg" class="" />{{
              $t("this_event_sales_complated")
            }}</span
          >&nbsp<span
            v-if="
              $user != null &&
              !$user.onlySalesPerson &&
              !$user.isOnlyTrainerContry
            "
            >{{ $t("if_you_want_to_mark_as_incomplate") }}</span
          >&nbsp<a
            v-if="
              $user != null &&
              !$user.onlySalesPerson &&
              !$user.isOnlyTrainerContry
            "
            @click="updateStatus(false)"
            class="stutus_click"
            >{{ $t("click_here") }}</a
          >
        </p>

        <!-- Left Area -->
        <div class="col-xl-9 innersales">
          <div class="px-md-4 mx-0 pa-0 text-content">
            <div class="row disablerow justify-content-between">
              <div class="col-md-12 row disablerow align-items-start">
                <div class="col-md-6">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('eventNrsales') + '*'"
                    v-model="request.eventNumber"
                  ></v-text-field>
                </div>
                <div class="col-md-12 pt-4 mb-3 margin-wrapper">
                  <span class="headlinecolor formheading">
                    {{ $t("sales-information") }}
                  </span>
                </div>
                <div class="col-md-12 row disablerow align-items-start">
                  <div class="col-md-4 row disablerow">
                    <div class="col-12 ttss">
                      <v-select
                        hide-details="auto"
                        :items="sortedCountries"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('country') + '*'"
                        v-model="request.country"
                        @change="changeCountry()"
                      ></v-select>
                    </div>

                    <!-- <div class="col-12">
                            <DatePicker
                            v-model="request.inquiryDate"
                            clearable
                            :label="$t('inquiry_date')"
                            />
                        </div> -->
                    <div
                      class="col-12"
                      v-if="
                        selectableProjects.length != 0 &&
                        request.country != null
                      "
                    >
                      <v-select
                        hide-details="auto"
                        :items="selectableProjects"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        item-text="text"
                        item-value="value"
                        :label="$t('salesprojects') + '*'"
                        v-model="request.project"
                        @change="changeProjects(request.project)"
                      ></v-select>
                    </div>

                    <div class="col-12">
                      <v-text-field
                        v-if="
                          selectableProjects.length == 0 &&
                          request.country != null
                        "
                        hide-details="auto"
                        class="datainput justify-content-end align-self-center pb-1"
                        dense
                        outlined
                        :label="$t('salesprojects') + '*'"
                        v-model="request.projectText"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="col-md-4 row disablerow">
                    <div class="col-12">
                      <MonthPicker
                        v-model="request.salesMonth"
                        clearable
                        :label="$t('sales_month')"
                      />
                    </div>
                    <div class="col-12">
                      <DatePicker
                        v-model="request.orderDate"
                        clearable
                        :label="$t('inquiry_date')"
                      />
                    </div>
                  </div>
                  <div class="col-md-4 row disablerow">
                    <div class="col-12">
                      <v-select
                        hide-details="auto"
                        :items="selectableSalesSource"
                        class="datainput justify-content-end align-self-center"
                        dense
                        outlined
                        :label="$t('salesSource') + '*'"
                        v-model="request.salesSource"
                        @change="changeCountry()"
                      ></v-select>
                    </div>
                    <div class="col-12">
                      <v-select
                        hide-details="auto"
                        :items="selectableProcessingStatus"
                        class="datainput justify-content-end align-self-center"
                        dense
                        outlined
                        :label="$t('processing-status')"
                        v-model="request.processingStatus"
                      ></v-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pt-1 mb-3 margin-wrapper">
                <span class="headlinecolor formheading"
                  >{{ $t("training-request-information") }}
                </span>
              </div>
              <div class="col-md-12 row disablerow align-items-start">
                <div class="col-md-6 row disablerow">
                  <div class="col-12">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('editor-name')"
                      v-model="request.editorName"
                      :disabled="
                        $user &&
                        $user != null &&
                        !$user.roles.includes('SUPERADMIN')
                      "
                    ></v-text-field>
                  </div>

                  <div class="col-12">
                    <v-tooltip slot="append" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-autocomplete
                          v-model="request.eventTrainingCategoryId"
                          hide-details="auto"
                          class="datainput justify-content-end searchbar align-self-center pb-1"
                          :items="trainingEventCategories1"
                          item-text="text"
                          item-value="value"
                          style="padding-right: 2px"
                          dense
                          outlined
                          clearable
                          v-bind="attrs"
                          v-on="on"
                          :label="$t('training_event_category')"
                          @change="disableTraining()"
                          :disabled="trainingCategoryDisabled"
                        >
                        </v-autocomplete>
                      </template>
                    </v-tooltip>

                    <div
                      v-if="filteredCategories && showCategory"
                      class="trn_cat"
                    >
                      <p class="training-category-lebel">
                        {{ $t("category") }}
                      </p>
                      <div class="list-component list-componant-wrapper">
                        <v-list class="v-list-flex v-list_custom">
                          <v-list-item
                            class="v-list-item-wrap"
                            v-for="cat in filteredCategories"
                            :key="cat.value"
                          >
                            <v-list-item-content>
                              {{ cat.text }}
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('other_training')"
                      v-model="request.otherTraining"
                    ></v-text-field>
                  </div>

                  <div class="col-12">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('vehicleType')"
                      v-model="request.vehicleType"
                    ></v-text-field>
                  </div>
                </div>

                <div class="col-md-6 row disablerow">
                  <div class="col-12">
                    <v-autocomplete
                      :disabled="disableSalesContact"
                      v-model="request.salesContact"
                      hide-details="auto"
                      class="datainput justify-content-end searchbar align-self-center pb-1"
                      :items="users"
                      item-text="text"
                      item-value="value"
                      style="padding-right: 2px"
                      dense
                      outlined
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      :label="$t('sales_contact')"
                    >
                    </v-autocomplete>
                    <!-- <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('sales_contact')"
                      v-model="request.salesContact"
                    ></v-text-field> -->
                  </div>

                  <div class="col-12">
                    <v-tooltip slot="append" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-autocomplete
                          v-model="request.trainingSales"
                          hide-details="auto"
                          class="datainput justify-content-end searchbar align-self-center pb-1"
                          :items="sortedTrainings"
                          item-text="text"
                          item-value="value"
                          style="padding-right: 2px"
                          dense
                          outlined
                          clearable
                          v-bind="attrs"
                          v-on="on"
                          :label="$t('training')"
                          :disabled="trainingDisabled"
                          @change="disableTrainingEventCategory()"
                        >
                        </v-autocomplete>
                      </template>
                    </v-tooltip>
                  </div>

                  <div class="col-12 cmft">
                    <v-text-field
                      hide-details="auto"
                      class="datainput justify-content-end align-self-center pb-1"
                      dense
                      outlined
                      :label="$t('customer')"
                      v-model="request.customer"
                      @focusout="onInput"
                    ></v-text-field>
                    <!-- <p class="cm_error">{{  $t("customer_msg_for_tenant") }}</p> -->
                  </div>
                </div>
              </div>
              <div class="col-md-12 pt-1 mb-3 margin-wrapper">
                <span class="headlinecolor formheading">
                  {{ $t("other_information") }}
                </span>
              </div>

              <!-- Row 1: Project Number, Debtor Number, Service Order -->
              <div class="col-md-12 disablerow d-flex align-base">
                <!-- <div class="col-md-4">
    <v-text-field
      hide-details="auto"
      class="datainput justify-content-end align-self-center"
      dense
      outlined
      :label="$t('project_number')"
      v-model="request.projectNumber"
      :disabled="
        request.stakeHolder === 'Urban' ||
        request.stakeHolder === 'DB' ||
        request.stakeHolder === 'Mainline'
      "
    ></v-text-field>
  </div> -->
                <div class="col-md-4">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center"
                    dense
                    outlined
                    :label="$t('debtor_number') + '*'"
                    v-model="request.debtorNumber"
                    @focusout="filterCustomerName"
                  ></v-text-field>
                </div>
                <div class="col-md-4">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center"
                    dense
                    outlined
                    :label="$t('service_order')"
                    v-model="request.serviceOrder"
                  ></v-text-field>
                </div>
                <div class="col-md-4">
                  <DatePicker
                    v-model="request.effectiveDate"
                    clearable
                    :label="$t('effective_date')"
                  />
                </div>
                <div class="col-md-4">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center"
                    dense
                    outlined
                    :label="$t('offer_number')"
                    v-model="request.offerNumber"
                  ></v-text-field>
                </div>
                <div class="col-md-4">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('offer_amount')"
                    v-model="offerAmountInput"
                    @blur="validateOfferAmount"
                    prefix="€"
                  ></v-text-field>
                </div>
                <div class="col-md-4">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center"
                    dense
                    outlined
                    :label="$t('bill_number')"
                    v-model="request.billNumber"
                  ></v-text-field>
                </div>
                <div class="col-md-4">
                  <DatePicker
                    v-model="request.dateOfInvoice"
                    clearable
                    :label="$t('date_of_invoice')"
                  />
                </div>
                <div class="col-md-4">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('invoice_amount')"
                    v-model="invoiceAmountInput"
                    @blur="validateInvoiceAmount"
                    prefix="€"
                  ></v-text-field>
                </div>
              </div>

              <div class="col-md-12 pb-4">
                <Upload
                  v-model="request.internalDocuments"
                  multiple
                  allowOtherFileTypes
                  internalFiles
                />
                <div class="upload-limit-text">{{ $t("max_size_1000mb") }}</div>
              </div>
              <div class="col-md-12 pb-4">
                <v-textarea
                  hide-details="auto"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  :label="$t('comment')"
                  v-model="request.remarks"
                  @input="updateCharacterCountComments"
                ></v-textarea>
                <div class="upload-limit-text-1">
                  <span
                    :style="{
                      color: characterCountComments > 6000 ? 'red' : 'inherit',
                    }"
                  >
                    {{ characterCountComments }}</span
                  >
                  /{{ 6000 }} {{ $t("characters") }}
                  <div v-if="characterCountComments > 6000" style="color: red">
                    {{ $t("characterExceeded") }}
                  </div>
                  <!-- {{ characterCountComments }} /6000 {{ $t("characters") }} -->
                </div>
              </div>
              <div class="text-right mb-1 wn-mx">
                <v-label> * {{ $t("mandatory_fields") }} </v-label>
              </div>
              <div class="row lastBtnSubmit sale-last-btn-submit">
                <div class="sale_list_btn_left p-0">
                  <v-btn
                    v-if="!editMode"
                    @click="insertUpdate()"
                    v-show="$rights.includes('CREATE_SALESLIST')"
                    outlined
                    depressed
                    tile
                    class="savebutton mr-2"
                    >{{ $t("save") }}</v-btn
                  >
                  <v-btn
                    v-else
                    @click="insertUpdate()"
                    v-show="$rights.includes('UPDATE_SALESLIST')"
                    outlined
                    depressed
                    tile
                    class="savebutton mr-2"
                    >{{ $t("save") }}</v-btn
                  >

                  <v-btn
                    @click="$routerBack()"
                    outlined
                    depressed
                    tile
                    class="cancelBtn mr-2"
                  >
                    {{ $t("cancel") }}</v-btn
                  >
                  <v-btn
                    v-show="
                      editMode == true && $rights.includes('DELETE_SALESlIST')
                    "
                    @click="openDeleteDialog = true"
                    outlined
                    depressed
                    tile
                    class="deletebutton cancelBtn"
                  >
                    <v-icon color="#444">mdi-delete</v-icon>
                    {{ $t("delete") }}</v-btn
                  >
                </div>
                <div class="sale_list_btn_right p-0 justify-content-right">
                  <v-btn
                    v-if="editMode"
                    @click="updateStatus(true)"
                    v-show="
                      $rights.includes('UPDATE_SALESLIST') &&
                      !request.completedStatus
                    "
                    outlined
                    depressed
                    tile
                    class="link_btn m-0"
                    ><img src="/static/img/link-btn-icon.svg" class="mr-1" />{{
                      $t("mark_as_completed")
                    }}</v-btn
                  >
                </div>
              </div>
            </div>
            <!--  -->
            <div class="text-center">
              <v-dialog v-model="openDeleteDialog" width="500">
                <h4 class="align_center">{{ $t("delete_SalesList") }}</h4>
                <v-card-actions class="align_center">
                  <v-btn
                    @click="openDeleteDialog = false"
                    outlined
                    depressed
                    tile
                    class="cancelBtn mr-2 mb-2"
                  >
                    {{ $t("cancel") }}</v-btn
                  >
                  <v-btn
                    v-show="$rights.includes('DELETE_SALESlIST')"
                    @click="deleteSales()"
                    outlined
                    depressed
                    tile
                    class="savebutton mb-2"
                  >
                    <img
                      src="/static/img/popup-delete-icon.svg"
                      class="popup-delete-icon"
                    />
                    {{ $t("delete") }}</v-btn
                  >
                </v-card-actions>
              </v-dialog>
            </div>
            <!--  -->
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 ml-1 px-0 pl-md-12 pl-lg-8 row pt-0 onlyContact">
          <div v-if="editMode" class="col-xl-12 right-side-block">
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <div class="d-flex g-space-15">
              <v-btn
                @click="download()"
                v-show="$rights.includes('DOWNLOAD_SALES_LIST')"
                outlined
                depressed
                tile
                class="downBtn savebutton"
              >
                <v-icon class="download-icon" color="#444" small
                  >fas fa-file-pdf</v-icon
                >
                {{ $t("downloadpdf") }}</v-btn
              >
              <v-btn
                v-if="editMode && request.trainingEvent == null"
                v-show="$rights.includes('CREATE_TRAINING_EVENT')"
                @click="createTrainingEvent()"
                outlined
                depressed
                tile
                class="savebutton"
                >{{ $t("create_trainingEvent") }}</v-btn
              >
              <v-btn
                v-if="
                  editMode &&
                  request.trainingEvent &&
                  $user &&
                  !$user.isOnlySalesPersonCountry
                "
                v-show="$rights.includes('VIEW_TRAINING_EVENT')"
                @click="onCellClicked()"
                outlined
                depressed
                tile
                class="savebutton"
                >{{ $t("view_trainingEvent") }}</v-btn
              >
              <v-btn
                v-show="
                  editMode &&
                  !request.completedStatus &&
                  $rights.includes('CREATE_SALESLIST') &&
                  !$user.isOnlySalesPersonCountry &&
                  !$user.isOnlyTrainerContry
                "
                @click="createDuplicateSales()"
                outlined
                depressed
                tile
                class="savebutton"
              >
                <v-icon class="duplicate-icon" color="#ffffff" small
                  >fa-light fa-copy</v-icon
                >
                {{ $t("duplicate_sales_list") }}</v-btn
              >

              <v-btn
                v-if="request.trainingRequest"
                :href="`request?trainingRequestId=` + request.trainingRequest"
                v-show="$rights.includes('VIEW_TRAINING_REQUESTS')"
                outlined
                depressed
                tile
                class="savebutton"
                >{{ $t("view_training_request") }}</v-btn
              >
              <v-btn
                v-if="request.duplicateFrom"
                :href="`/sales-request?salesListId=` + request.duplicateFrom"
                v-show="$rights.includes('VIEW_TRAINING_REQUESTS')"
                outlined
                depressed
                tile
                class="savebutton"
                >{{ $t("View_Original_Sales_list") }}</v-btn
              >
            </div>
          </div>

          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  props: {
    trainingId: Number,
    trainingRequestId: Number,
  },

  data() {
    return {
      offerAmountInput: "", // For raw input
      invoiceAmountInput: "", // For raw input
      customers: [],
      disableSalesContact: true,
      users: [],
      selectableProjects: [],
      trainings: [],
      countries: [],
      salesListId: null,

      salesList: [],
      salesList_page: 1,
      salesList_totalPages: 1,
      salesList_ElementPerPage: 50,
      salesList_sort: null,
      salesList_order: true,

      editMode: false,
      openDeleteDialog: false,
      characterCountCustomerComments: 0,
      characterCountComments: 0,
      request: {
        trainingEventId: null,
        salesSource: null,
        trainingSales: null,
        eventNumber: null,
        customer: null,
        projects: null,
        editorName: null,
        salesContact: null,
        processingStatus: null,
        orderDate: null,
        value1ForEvaluation: null,
        projectNumber: null,
        debtorNumber: null,
        serviceOrder: null,
        offerAmount: null,
        offerNumber: null,
        salesMonth: null,
        dateOfInvoice: null,
        effectiveDate: null,
        billNumber: null,
        invoiceAmount: null,
        remarks: null,
        id: null,
        country: null,
        otherTraining: null,
        trainingRequestId: null,
        eventTrainingCategoryId: null,
        project: null,
        // inquiryDate:null,
        vehicleType: null,
        internalDocuments: [],
        duplicateFrom: null,
      },
      tenants: null,
      trainingRequest: null,
      routes: {
        tenants: "/api/tenant/tenants",
      },
      trainingEventCategories: [],
      trainingCategories: [],
      trainingDisabled: false,
      trainingCategoryDisabled: false,
      showCategory: false,
      //   trainingRequestId: null,
    };
  },
  computed: {
    filteredSuggestions() {
      const lowerQuery = this.request.customer.toLowerCase();
      return this.suggestions.filter((s) =>
        s.toLowerCase().startsWith(lowerQuery)
      );
    },

    selectableSalesSource() {
      //if(this.request.country == 'GERMANY'){
      return [
        {
          value: "3P",
          text: "3P",
        },
        {
          value: "IC",
          text: "IC",
        },
        {
          value: "OE",
          text: "OE",
        },
        {
          value: "IV",
          text: "IV",
        },
      ];
      //}else{
      //     return [
      //       {
      //         value: "IC",
      //         text: "IC",
      //       },
      //       {
      //         value: "OE",
      //         text: "OE",
      //       },
      //       {
      //         value: "IV",
      //         text: "IV",
      //       }
      //     ]
      //  }
    },
    selectableProcessingStatus() {
      return [
        { value: "open", text: this.$t("opens") },
        {
          value: "inprogress",
          text: this.$t("in_progress"),
        },
        {
          value: "offersent",
          text: this.$t("offer_sent"),
        },
        {
          value: "quotation",
          text: this.$t("quotation"),
        },
        {
          value: "orderreceived",
          text: this.$t("order_received"),
        },
        {
          value: "onhold",
          text: this.$t("on_hold"),
        },
        {
          value: "invoicing",
          text: this.$t("invoicing"),
        },
        {
          value: "opentraining",
          text: this.$t("open_training"),
        },
        {
          value: "invoicecreated",
          text: this.$t("invoice_created"),
        },
      ];
    },
    filteredCategories() {
      if (this.request.eventTrainingCategoryId) {
        const filteredCategories = [];
        for (const catGroup of this.trainingEventCategories) {
          if (catGroup.id === this.request.eventTrainingCategoryId) {
            for (const cat of catGroup.category) {
              if (
                cat.designationMap[this.$locale] != null &&
                cat.designationMap[this.$locale] != ""
              ) {
                filteredCategories.push({
                  value: cat.id,
                  text: cat.designationMap[this.$locale],
                });
              }
            }
          }
        }
        return filteredCategories;
      }
    },

    trainingEventCategories1() {
      const trainingEventCategories = Array.isArray(
        this.trainingEventCategories
      )
        ? this.trainingEventCategories
            .filter((trainingEventCategory) => {
              // Ensure both designationsMap and locale-specific designation are valid (not null or undefined)
              const designationMap = trainingEventCategory.designationsMap;
              const localeDesignation = designationMap?.[this.$locale];
              // Keep only if both designationsMap and locale-specific designation exist
              return designationMap && localeDesignation;
            })
            .map((trainingEventCategory) => ({
              value: trainingEventCategory.id,
              text: trainingEventCategory.designationsMap[this.$locale],
            }))
            .sort((a, b) => {
              const textA = a.text ? a.text.trim().toLowerCase() : "";
              const textB = b.text ? b.text.trim().toLowerCase() : "";
              return textA.localeCompare(textB, this.$locale, {
                sensitivity: "base",
              });
            })
        : [];
      return trainingEventCategories;
    },
    sortedTrainings() {
      return this.trainings.sort((a, b) => {
        const textA = a.text ? a.text.trim().toLowerCase() : "";
        const textB = b.text ? b.text.trim().toLowerCase() : "";
        return textA.localeCompare(textB, this.$locale, {
          sensitivity: "base",
        });
      });
    },
    watchedTraining() {
      // Extract customer from the request object
      return this.request.trainingSales;
    },

    sortedCountries() {
      return this.countries
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
  },
  watch: {
    filteredCategories: {
      handler(newVal, oldVal) {},
      deep: true,
      immediate: true,
    },
    watchedTraining: {
      handler(newVal, oldVal) {
        if (newVal !== null && this.$route.query.trainingRequestId != null) {
          //this.editMode = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.callSalesList();
  },
  updated() {
    if (!this.request.editorName && this.$user) {
      this.disableSalesContact = !this.$user.roles.includes("SUPERADMIN");
      this.request.editorName = this.$user.fullname;
    }
    // if (!this.request.salesContact &&  this.$user) {
    //   this.request.salesContact = this.$user.fullname;
    // }
    let _this = this;
    let country = _this.request.country;
    if (_this.request.eventNumber && _this.request.country) {
      const countryPrefixes = {
        GERMANY: "DE_",
        AUSTRIA: "AU_",
        SWITZERLAND: "CH_",
        SPAIN: "ES_",
        FRANCE: "FR_",
        UNITED_KINGDOM: "GB_",
        HUNGARY: "HU_",
        ITALY: "IT_",
        KAZAKHSTAN: "KZ_",
        POLAND: "PL_",
        NORDIC: "ND_",
        RUSSIA: "RU_",
        CHINA: "CN_", // Including as it was in the original code
      };

      if (countryPrefixes[country]) {
        _this.request.eventNumber = _this.request.eventNumber.replace(
          /^[^_]*_/,
          countryPrefixes[country]
        );
      } else {
        console.error("Country not found in prefixes:", country);
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.callSalesList(); // Reapply state
    next();
  },

  methods: {
    callSalesList() {
      this.fetchTrainings();
      this.fetchCountries();
      this.fetchCustomers();
      const storedRequest = sessionStorage.getItem("duplicatedSalesRequest");
      if (storedRequest) {
        if (this.$route.query.salesListId) this.$route.query.salesListId = null;
        if (this.$route.query.trainingRequestId)
          this.$route.query.trainingRequestId = null;
        this.request = { ...this.request, ...JSON.parse(storedRequest) };
        sessionStorage.removeItem("duplicatedSalesRequest"); // Clear after use
        this.$forceUpdate();
      }

      if (this.trainingId != null)
        this.request.trainingId = parseInt(this.trainingId);
      if (this.eventTrainingCategoryId != null)
        this.request.eventTrainingCategoryId = parseInt(
          this.eventTrainingCategoryId
        );

      if (this.$route.query.salesListId != null) {
        this.salesListId = parseInt(this.$route.query.salesListId, 10);
        this.editMode = true;
        this.getSalesList();
      }

      if (this.$route.query.trainingRequestId != null) {
        this.trainingRequestId = parseInt(this.$route.query.trainingRequestId);
        this.request.trainingRequestId = parseInt(
          this.$route.query.trainingRequestId
        );
        this.fetchEditingTrainingRequest();
      }

      if (!this.request.eventNumber || this.request.eventNumber.trim() === "") {
        this.getEventNumber();
      }
    },
    onInput() {
      const value = this.request.customer; // Get value from v-model

      const matchingCustomers = this.customers.filter(
        (customer) =>
          customer.name.toLowerCase().trim() === value.toLowerCase().trim()
      );
      if (matchingCustomers.length > 0) {
        this.request.debtorNumber = matchingCustomers.map(
          (customer) => customer.debitor
        )[0];
      } else {
        // this.request.debtorNumber = null;
      }
    },
    filterCustomerName() {
      const value = this.request.debtorNumber; // Get value from v-model

      const matchingCustomers = this.customers.filter(
        (customer) =>
          customer.debitor &&
          typeof customer.debitor === "string" &&
          typeof value === "string" &&
          customer.debitor.toLowerCase().trim() === value.toLowerCase().trim()
      );
      console.log(matchingCustomers);
      if (matchingCustomers.length > 0) {
        this.request.customer = matchingCustomers.map(
          (customer) => customer.name
        )[0];
      }
    },

    // Validate Offer Amount on blur
    validateOfferAmount() {
      this.offerAmountInput = this.validateAndFormatAmount(
        this.offerAmountInput
      );
      this.request.offerAmount = this.convertToNumber(this.offerAmountInput);
    },

    // Validate Invoice Amount on blur
    validateInvoiceAmount() {
      this.invoiceAmountInput = this.validateAndFormatAmount(
        this.invoiceAmountInput
      );
      this.request.invoiceAmount = this.convertToNumber(
        this.invoiceAmountInput
      );
    },

    // Convert US-style input (like 444444444.98) to German-style
    correctInputFormat(input) {
      // If input is US-style (digits with a dot before 2 decimals), convert it
      const usStyleRegex = /^\d+(\.\d{1,2})?$/;
      if (usStyleRegex.test(input)) {
        return input.replace(/\./, ",");
      }

      // If input is US-style with thousand separators (e.g. 1,234.98)
      const usThousandStyleRegex = /^\d{1,3}(,\d{3})*(\.\d{1,2})?$/;
      if (usThousandStyleRegex.test(input)) {
        return input.replace(/,/g, "").replace(/\./, ",");
      }

      return input; // Return as-is if no match
    },

    // Validate and format to German style
    validateAndFormatAmount(input) {
      if (!input) return "";

      // Fix US-style formats if detected
      input = this.correctInputFormat(input);

      // If already German-style, just append ,00 if needed
      const germanFormatRegex = /^\d{1,3}(\.\d{3})*(,\d{1,2})?$/;
      if (germanFormatRegex.test(input)) {
        return input.includes(",") ? input : `${input},00`;
      }

      // Standard number formatting
      let number = parseFloat(input.replace(/\./g, "").replace(",", "."));
      if (isNaN(number)) return input;

      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
    },

    // Convert German formatted string to number (for backend)
    convertToNumber(input) {
      if (!input) return null;
      return parseFloat(input.replace(/\./g, "").replace(",", "."));
    },

    updateStatus(status) {
      if (this.salesListId == null) return;
      var _this = this;

      _this.$axios
        .post(
          "/api/saleslist/update-status/" + _this.salesListId + "/" + status
        )
        .then(function (response) {
          _this.request = response.data;

          _this.request = response.data;
          // _this.request.invoiceAmount = _this.formatCurrency(
          //   _this.request.invoiceAmount
          // );
          if (response.data.salesContact != null) {
            if (response.data.salesContact && response.data.salesContact.id) {
              _this.request.salesContact = response.data.salesContact.id;
            }
          }
          // _this.request.offerAmount = _this.formatCurrency(
          //   _this.request.offerAmount
          // );
          if (response.data.trainingRequest != null) {
            _this.request.trainingRequestId = response.data.trainingRequest;
          }

          if (_this.request.trainingSales != null) {
            _this.$set(
              _this.request,
              "trainingSales",
              response.data.trainingSales
                ? response.data.trainingSales.id
                : null
            );
          }

          if (response.data.eventTrainingCategory != null) {
            _this.$set(
              _this.request,
              "eventTrainingCategoryId",
              response.data.eventTrainingCategory
                ? response.data.eventTrainingCategory.id
                : null
            );
          }

          if (_this.request.project != null) {
            _this.request.project = _this.request.project.id;
          }

          _this.salesList = _this.request;
          if (!_this.request.editorName) {
            _this.request.editorName = _this.$user.fullname;
          }

          _this.changeCountry();

          if (_this.request.eventTrainingCategoryId) {
            _this.trainingDisabled = true;
            _this.showCategory = true;
            _this.$set(_this.request, "trainingSales", null);
          } else if (_this.request.trainingSales) {
            _this.trainingCategoryDisabled = true;
            _this.showCategory = false;
            _this.$set(_this.request, "eventTrainingCategoryId", null);
          }

          _this.request.projectText = response.data.projectText;

          if (_this.request.remarks !== null) {
            _this.characterCountComments = _this.request.remarks.length;
          }

          if (response.data.trainingEvent != null) {
            _this.$set(
              _this.request,
              "trainingEventId",
              response.data.trainingEvent
                ? response.data.trainingEvent.id
                : null
            );
          }

          _this.request.completedStatus = response.data.completedStatus;

          if (status == true) {
            _this.$noty.success(
              _this.$t("sales_list_marked_as_completed_success")
            );
          } else {
            _this.$noty.success(
              _this.$t("sales_list_marked_as_incompleted_success")
            );
          }
        })
        .catch(_this.onError);
    },

    changeEventNumber() {
      let _this = this;
      let country = _this.request.country;
      if (_this.request.eventNumber) {
        if (country === "GERMANY") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "GB_"
          ); // UK
        } else if (country === "POLAND") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "PL_"
          ); // Poland
        } else if (country === "FRANCE") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "FR_"
          ); // France
        } else if (country === "HUNGARY") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "HU_"
          ); // Hungary
        } else if (country === "SPAIN") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "ES_"
          ); // Spain
        } else if (country === "RUSSIA") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "RU_"
          ); // Russia
        } else if (country === "KAZAKHSTAN") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "KZ_"
          ); // Kazakhstan
        } else if (country === "CHINA") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "CN_"
          );//CHINA
        }else if (country === "ITALY") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "IT_"
          ); // Italy
        } else if (country === "GERMANY") {
          _this.request.eventNumber = _this.request.eventNumber.replace(
            /^[^_]*_/,
            "DE_"
          ); // Germany
        }
      }
    },

    fetchAllLocationManagers() {
      var _this = this;
      _this.users = [];
      this.$axios
        .get("/api/user/locationManager")
        .then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            if (Number.isInteger(element)) {
              _this.fetchSingleLocationManagerAndPush(element);
            } else {
              _this.users.push({ text: element.fullname, value: element.id });
            }
          }
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    fetchSingleLocationManagerAndPush(locationManagerId) {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/user/" + locationManagerId)
        .then(function (response) {
          const element = response.data;
          _this.users.push({ text: element.fullname, value: element.id });
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    getEventNumber() {
      var _this = this;
      this.$axios.get("/api/training/event/eventNo").then(function (response) {
        if (
          !_this.request.eventNumber ||
          _this.request.eventNumber.trim() === ""
        ) {
          _this.request.eventNumber = response.data;
        }
      });
    },
    changeCountry() {
      this.fetchAllProjects();
      this.changeEventNumber();
      this.fetchAllLocationManagers();
    },
    fetchAllProjects() {
      var _this = this;
      this.$axios
        .get("/api/project/get-all-project")
        .then(function (response) {
          if (_this.request.country && _this.request.salesSource) {
            let projectsFiltered1 = response.data.filter(
              (project) =>
                project.country == _this.request.country &&
                project.salesSource == _this.request.salesSource
            );

            let projectsFiltered2 = projectsFiltered1.filter(
              (project) => project.salesSource == _this.request.salesSource
            );
            _this.selectableProjects = projectsFiltered2.map((project) => ({
              value: project.id,
              text: project.designations,
              projectNumber: project.projectNumber,
            }));

            if (_this.selectableProjects.length > 0) {
              _this.request.projectText = null;
            } else {
              _this.request.project = null;
            }
          }
        })
        .catch(this.onError);
    },
    changeSalesSource() {
      if (
        this.request.stakeHolder === "3P" ||
        this.request.stakeHolder === "IC" ||
        this.request.stakeHolder === "OE" ||
        this.request.stakeHolder === "IV"
      ) {
        this.request.projectNumber = "";
      }
    },
    changeProjects(value) {
      const projectNumber = this.selectableProjects.find(
        (project) => project.value === value
      )?.projectNumber;
      this.request.projectNumber = projectNumber;
    },
    formatCurrency(value) {
      // Split the value into integer and decimal parts
      let [integerPart, decimalPart] = value.toString().split(".");

      // Add comma after every three digits from right to left in the integer part
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // Join the integer and decimal parts, if decimal part exists
      return decimalPart ? integerPart + "." + decimalPart : integerPart;
    },

    createTenant() {
      if (this.trainingRequestId == null) return;
      var _this = this;
      this.sendRequest(true, function () {
        _this.$axios
          .post(
            "/api/training/request/" +
              _this.trainingRequestId +
              "/create-tenant"
          )
          .then(function (response) {
            const customerName =
              _this.request.customer == null
                ? _this.request.customer
                : _this.request.customer + " " + _this.request.customerLocation;
            _this.$noty.success(
              _this.$t("tenant_saved", { name: customerName })
            );
          })
          .catch(_this.onError);
      });
    },

    fetchCustomers() {
      var _this = this;
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get("/api/tenant/customers/all")
        .then(function (response) {
          _this.customers = response.data;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    fetchCountries() {
      this.$axios
        .get("/api/location/countries")
        .then((response) => {
          this.countries = response.data;
        })
        .catch(this.onError);
    },
    createTrainingEvent() {
      this.$router.push(
        "/create-training-event?salesListId=" +
          this.salesListId +
          "&lang=" +
          this.$locale.toUpperCase()
      );
    },
    fetchEditingTrainingRequest() {
      var _this = this;
      this.$axios
        .get("/api/training/request/" + this.trainingRequestId)
        .then(function (response) {
          _this.trainingRequest = response.data;
          if (response.data.locationManager != null) {
            if (
              response.data.locationManager &&
              response.data.locationManager.id
            ) {
              _this.request.salesContact = response.data.locationManager.id;
            }
          }
          //  _this.request.eventTrainingCategoryId = response.data.eventCategory.id;
          _this.$set(
            _this.request,
            "eventTrainingCategoryId",
            response.data.eventCategory != null
              ? response.data.eventCategory.id
              : null
          );
          if (_this.trainingRequest.salesList != null) {
            _this.request = _this.trainingRequest.salesList;
          } else {
            _this.$set(
              _this.request,
              "trainingSales",
              response.data.training != null ? response.data.training.id : null
            );
            if (response.data.country !== null) {
              _this.request.country = response.data.locationcountry;
              if (
                _this.request.country === "NORWAY" ||
                _this.request.country === "SWEDEN" ||
                _this.request.country === "DENMARK"
              ) {
                _this.request.country = "NORDIC";
              }
            }
            if (response.data.vehicle) {
              _this.request.vehicleType = response.data.vehicle;
            }

            if (response.data.otherTraining) {
              _this.request.otherTraining = response.data.otherTraining;
            }
            // _this.request.inquiryDate = response.data.createdAt;
            _this.fetchTenants();
          }
          if (_this.request.eventTrainingCategoryId) {
            _this.trainingDisabled = true;
            _this.showCategory = true;
            _this.$set(_this.request, "trainingSales", null);
          }
          if (_this.request.training) {
            _this.trainingDisabled = true;
            _this.showCategory = true;
            _this.$set(_this.request, "eventTrainingCategoryId", null);
          }
          if (response.data.customerComments) {
            _this.request.remarks = response.data.customerComments + "\n";
          }

          if (response.data.comments) {
            _this.request.remarks += response.data.comments;
          }

          if (_this.request.remarks) {
            _this.characterCountComments = _this.request.remarks.length;
          }

          if (response.data.createdAt) {
            const formattedDate = response.data.createdAt.split("T")[0];
            _this.request.orderDate = formattedDate;
          }
          console.log(response.data.pdfDocument);
          if (
            response.data.pdfDocument &&
            _this.request.internalDocuments &&
            !_this.request.internalDocuments.includes(response.data.pdfDocument)
          ) {
            _this.request.internalDocuments.push(response.data.pdfDocument);
          }

          _this.changeCountry();
        })
        .catch(this.onError);
    },
    fetchTenants() {
      var _this = this;
      this.$axios
        .get(this.routes.tenants, {})
        .then(function (response) {
          _this.tenants = response.data;
          for (let i = 0; i < _this.tenants.length; i++) {
            if (
              _this.trainingRequest.customerNumber !== null &&
              _this.trainingRequest.customerNumber !== "" &&
              _this.tenants[i].debitor === _this.trainingRequest.customerNumber
            ) {
              _this.request.customer = _this.tenants[i].name;
              _this.request.debtorNumber = _this.trainingRequest.customerNumber;
            }
          }
          if (!_this.request.customer) {
            _this.request.customer =
              _this.trainingRequest.customerName +
              " " +
              _this.trainingRequest.customerLocation;
          }
          if (!_this.request.debtorNumber) {
            _this.request.debtorNumber = _this.trainingRequest.customerNumber;
          }
        })
        .catch(this.onError);
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    onFinally() {
      showLoadingCircle(false);
    },

    fetchTrainings() {
      var _this = this;
      this.$axios
        .get("/api/training/trainings")
        .then(function (response) {
          const trainings = response.data;
          for (let i = 0; i < trainings.length; i++) {
            const training = trainings[i];
            if (
              training.designationsMap[_this.$locale] != null &&
              training.designationsMap[_this.$locale] != ""
            ) {
              _this.trainings.push({
                text: training.designationsMap[_this.$locale],
                value: training.id,
              });
            }
          }
          _this.$forceUpdate();
        })
        .catch(this.onError);

      this.$axios
        .get("/api/eventTrainingCategory")
        .then(function (response) {
          let trainingEventCategories = response.data.content;

          if (trainingEventCategories.length > 0) {
            trainingEventCategories.sort((a, b) => {
              const designationA = a.designationsMap[_this.$locale] || "";
              const designationB = b.designationsMap[_this.$locale] || "";

              return designationA.localeCompare(designationB, undefined, {
                sensitivity: "base",
              });
            });
          }
          for (let i = 0; i < trainingEventCategories.length; i++) {
            const trainingEventCategory = trainingEventCategories[i];
            trainingEventCategory.text =
              trainingEventCategory.designationsMap[_this.$locale];
            trainingEventCategory.value = trainingEventCategory.id;
          }

          _this.trainingEventCategories = trainingEventCategories;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    deleteSales() {
      if (this.salesListId == null) {
        console.error(
          "You are not editing an existing training course request."
        );
        return;
      }

      var _this = this;

      this.$axios
        .delete("/api/saleslist/" + this.salesListId)
        .then(function (response) {
          _this.$noty.success(_this.$t("sales_deleted"));
          _this.$router.push("/sales-list");
        })
        .catch(this.onError);
    },

    createTenant() {
      if (this.trainingRequestId == null) return;
      var _this = this;
      this.sendRequest(true, function () {
        _this.$axios
          .post(
            "/api/training/request/" +
              _this.trainingRequestId +
              "/create-tenant"
          )
          .then(function (response) {
            const customerName =
              _this.request.customerLocation == null
                ? _this.request.customerName
                : _this.request.customerName +
                  " " +
                  _this.request.customerLocation;
            _this.$noty.success(
              _this.$t("tenant_saved", { name: customerName })
            );
            _this.fetchEditingTrainingRequest();
          })
          .catch(_this.onError);
      });
    },

    insertUpdate() {
      if (this.salesListId !== null) {
        this.editSalesList();
      } else {
        this.createSalesList();
      }
    },

    createSalesList() {
      var _this = this;
      var saveSalesList = {};

      if (!this.request.country) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("country") }));
        return;
      }

      if (!this.request.eventNumber) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("eventNumber") })
        );
        return;
      }
      if (!this.request.salesSource) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("salesSource") })
        );
        return;
      }
      if (!this.request.project && !this.request.projectText) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("projects") }));
        return;
      }

      if (!this.request.debtorNumber) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("debtor_number") })
        );
        return;
      }
      // const amountRegex = /^(\d*\.?\d+|\d{1,3}(,\d{3})*(\.\d+)?)$/;
      // if (this.request.offerAmount && !amountRegex.test( this.request.offerAmount)) {
      //   this.$noty.error(this.$t("invalid_value", { name: this.$t("offer_amount") }));
      //   return;
      // }

      //  if (this.request.invoiceAmount && !amountRegex.test( this.request.invoiceAmount)) {
      //   this.$noty.error(this.$t("invalid_value", { name: this.$t("invoice_amount") }));
      //   return;
      // }

      if (this.characterCountComments > 6000) {
        this.$noty.error(
          this.$t("character_exceeded", { name: this.$t("comment") })
        );
        return;
      }
      let locationManagerArray;

      if (_this.request.salesContact != null) {
        if (Number.isInteger(_this.request.salesContact)) {
          locationManagerArray = _this.request.salesContact;
        }
      }

      _this.request.salesContact = locationManagerArray;
      if (_this.request.salesContact != null) {
        _this.request.salesContact = _this.request.salesContact;
      }

      this.request.editorName = this.$user.fullname;
      //this.request.salesContact = this.$user.fullname;
      Object.assign(saveSalesList, this.request);

      this.$axios
        .post("/api/saleslist", saveSalesList)
        .then(function (response) {
          _this.$noty.success(_this.$t("saleslist_created"));
          var salesList = response.data;
          _this.page = 1;
          _this.$router.push("/sales-list");
        })
        .catch(this.onError);
    },
    updateCharacterCountComments() {
      this.characterCountComments = this.request.remarks.length;
    },
    editSalesList() {
      var _this = this;
      var saveTrainingRequest = {};
      this.request.id = this.salesListId;

      if (!this.request.country) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("country") }));
        return;
      }

      if (!this.request.salesSource) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("salesSource") })
        );
        return;
      }
      if (!this.request.project && !this.request.projectText) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("projects") }));
        return;
      }
      if (!this.request.debtorNumber) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("debtor_number") })
        );
        return;
      }

      // if (this.request.offerAmount !== null) {
      //   this.request.offerAmount = this.request.offerAmount.replace(/,/g, "");
      // }
      // if (this.request.invoiceAmount !== null) {
      //   this.request.invoiceAmount = this.request.invoiceAmount.replace(
      //     /,/g,
      //     ""
      //   );
      // }

      if (!this.request.eventNumber) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("eventNumber") })
        );
        return;
      }

      // const amountRegex = /^(\d*\.?\d+|\d{1,3}(,\d{3})*(\.\d+)?)$/;
      // if (this.request.offerAmount && !amountRegex.test( this.request.offerAmount)) {
      //   this.$noty.error(this.$t("invalid_value", { name: this.$t("offer_amount") }));
      //   return;
      // }

      //  if (this.request.invoiceAmount && !amountRegex.test( this.request.invoiceAmount)) {
      //   this.$noty.error(this.$t("invalid_value", { name: this.$t("invoice_amount") }));
      //   return;
      // }

      if (this.characterCountComments > 6000) {
        this.$noty.error(
          this.$t("character_exceeded", { name: this.$t("comment") })
        );
        return;
      }

      this.request.editorName = this.$user.fullname;
      let locationManagerArray;

      if (_this.request.salesContact != null) {
        if (Number.isInteger(_this.request.salesContact)) {
          locationManagerArray = _this.request.salesContact;
        }
      }

      _this.request.salesContact = locationManagerArray;
      if (_this.request.salesContact != null) {
        _this.request.salesContact = _this.request.salesContact;
      }
      if (this.request.trainingSales != null) {
        this.request.trainingSales = this.request.trainingSales;
      }
      Object.assign(saveTrainingRequest, this.request);
      this.$axios
        .put(
          "/api/saleslist/updateSalesList/" + this.salesListId,
          saveTrainingRequest
        )
        .then(function (response) {
          var salesList = response.data;
          _this.$noty.success(_this.$t("saleslist_updated"));
          _this.$router.push("/sales-list");
        })
        .catch(this.onError);
    },
    getSalesList() {
      var _this = this;
      this.$axios
        .get("/api/saleslist/" + this.salesListId)
        .then(function (response) {
          _this.request = response.data;
          // _this.request.invoiceAmount = _this.formatCurrency(
          //   _this.request.invoiceAmount
          // );
          _this.offerAmountInput = _this.request.offerAmount;
          _this.validateOfferAmount();
          _this.invoiceAmountInput = _this.request.invoiceAmount;
          _this.validateInvoiceAmount();
          if (response.data.salesContact != null) {
            if (response.data.salesContact && response.data.salesContact.id) {
              _this.request.salesContact = response.data.salesContact.id;
            }
          }
          // _this.request.offerAmount = _this.formatCurrency(
          //   _this.request.offerAmount
          // );
          if (response.data.trainingRequest != null) {
            _this.request.trainingRequestId = response.data.trainingRequest;
          }

          if (_this.request.trainingSales != null) {
            _this.$set(
              _this.request,
              "trainingSales",
              response.data.trainingSales
                ? response.data.trainingSales.id
                : null
            );
          }

          if (response.data.eventTrainingCategory != null) {
            _this.$set(
              _this.request,
              "eventTrainingCategoryId",
              response.data.eventTrainingCategory
                ? response.data.eventTrainingCategory.id
                : null
            );
          }

          if (_this.request.project != null) {
            _this.request.project = _this.request.project.id;
          }

          _this.salesList = _this.request;
          if (!_this.request.editorName) {
            _this.request.editorName = _this.$user.fullname;
          }

          _this.changeCountry();

          if (_this.request.eventTrainingCategoryId) {
            _this.trainingDisabled = true;
            _this.showCategory = true;
            _this.$set(_this.request, "trainingSales", null);
          } else if (_this.request.trainingSales) {
            _this.trainingCategoryDisabled = true;
            _this.showCategory = false;
            _this.$set(_this.request, "eventTrainingCategoryId", null);
          }

          _this.request.projectText = response.data.projectText;

          if (_this.request.remarks !== null) {
            _this.characterCountComments = _this.request.remarks.length;
          }

          if (response.data.trainingEvent != null) {
            _this.$set(
              _this.request,
              "trainingEventId",
              response.data.trainingEvent
                ? response.data.trainingEvent.id
                : null
            );
          }

          _this.request.completedStatus = response.data.completedStatus;

          // if(_this.request.invoiceAmount && _this.request.invoiceAmount != 0)
          // {
          //    //_this.request.offerAmount = 0;
          //    _this.disableOfferAmount = true;
          // }
        })
        .catch(this.onError);
    },

    download() {
      if (this.salesListId == null) return;
      var _this = this;
      this.$axios
        .get("/api/saleslist/" + _this.salesListId + "/download", {
          responseType: "blob",
        })
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "sales_request_" + _this.salesListId + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },

    disableTraining() {
      if (this.request.eventTrainingCategoryId) {
        this.trainingDisabled = true;
        this.showCategory = true;
        this.request.trainingSales = null;
      } else {
        this.trainingDisabled = false;
      }
    },
    disableTrainingEventCategory() {
      if (this.request.trainingSales) {
        this.trainingCategoryDisabled = true;
        this.request.eventTrainingCategoryId = null;
        this.showCategory = false;
      } else {
        this.trainingCategoryDisabled = false;
      }
    },
    createDuplicateSales() {
      let filteredRequest = {
        ...this.request,
        salesSource: null,
        projects: null,
        eventNumber: null,
        country: null,
        id: null,
        project: null,
        projects: null,
        projectNumberWithProjeccts: null,
        projectText: null,
        trainingRequestId: null,
      };
      this.request = {
        trainingEventId: null,
        salesSource: null,
        trainingSales: null,
        eventNumber: null,
        customer: null,
        projects: null,
        editorName: null,
        salesContact: null,
        processingStatus: null,
        orderDate: null,
        value1ForEvaluation: null,
        projectNumber: null,
        debtorNumber: null,
        serviceOrder: null,
        offerAmount: null,
        offerNumber: null,
        salesMonth: null,
        dateOfInvoice: null,
        effectiveDate: null,
        billNumber: null,
        invoiceAmount: null,
        remarks: null,
        id: null,
        country: null,
        otherTraining: null,
        trainingRequestId: null,
        eventTrainingCategoryId: null,
        project: null,
        vehicleType: null,
        internalDocuments: [],
        duplicateFrom: null,
        projectNumberWithProjeccts: null,
        projectText: null,
      };
      filteredRequest.duplicateFrom = this.salesListId;
      this.editMode = false;
      this.salesListId = null;
      sessionStorage.setItem(
        "duplicatedSalesRequest",
        JSON.stringify(filteredRequest)
      );
      this.$router.push({ path: "/sales-request", query: {} });
    },
    onCellClicked() {
      let _this = this;
      if (typeof _this.request.trainingEvent == "object") {
        if (this.request.trainingEvent.eventflag == "0") {
          _this.$router.push(
            "/edit-training-event?trainingEventId=" +
              _this.request.trainingEvent.id +
              "&lang=" +
              _this.$locale.toUpperCase()
          );
        } else if (this.request.trainingEvent.eventflag == "2") {
          _this.$router.push(
            "/edit-training-event?trainingEventId=" +
              _this.request.trainingEvent.id +
              "&eventStatus=drafted&lang=" +
              _this.$locale.toUpperCase()
          );
        } else if (this.request.trainingEvent.eventflag == "1") {
          _this.$router.push(
            "/edit-training-event?trainingEventId=" +
              _this.request.trainingEvent.id +
              "&eventStatus=cancelled&lang=" +
              _this.$locale.toUpperCase()
          );
        }
      } else {
        this.$axios
          .get("/api/training/event/" + _this.request.trainingEvent)
          .then(function (response) {
            if (response.data.eventflag == "0") {
              _this.$router.push(
                "/edit-training-event?trainingEventId=" +
                  _this.request.trainingEvent +
                  "&lang=" +
                  _this.$locale.toUpperCase()
              );
            } else if (response.data.eventflag.eventflag == "2") {
              _this.$router.push(
                "/edit-training-event?trainingEventId=" +
                  _this.request.trainingEvent +
                  "&eventStatus=drafted&lang=" +
                  _this.$locale.toUpperCase()
              );
            } else if (response.data.eventflag.eventflag == "1") {
              _this.$router.push(
                "/edit-training-event?trainingEventId=" +
                  _this.request.trainingEvent +
                  "&eventStatus=cancelled&lang=" +
                  _this.$locale.toUpperCase()
              );
            }
          })
          .catch(this.onError)
          .finally(this.onFinally);
      }
    },
  },
};
</script>